import { ReactNode, useCallback } from "react";
import clsx from "clsx";
import { CrossIcon } from "@/shared/icons";
import { Button } from "@/shared/ui";
import closeTablet from "@/domains/tablet/helpers/closeTablet";

type Props = {
  title: string;
  subTitle: string;
  src: string;
  children: ReactNode;
  isTablet?: boolean;
  onClose?: () => void;
};

export default function SelectScreenWrapper({
  title,
  subTitle,
  src,
  isTablet = true,
  onClose,
  children,
}: Props) {
  const handleClose = useCallback(() => {
    if (isTablet) closeTablet();
    if (onClose) onClose();
  }, [isTablet, onClose]);

  return (
    <div
      className={clsx(
        "absolute z-10 top-0 left-0 flex flex-col size-full p-7.5 bg-dark-900 rounded-4",
      )}
    >
      <div className="flex justify-between w-full">
        <div className="flex items-center gap-2.5">
          <img src={src} className="w-10.5 h-10.5" alt="logo" />
          <div>
            <div className="text-15 font-bold text-inverted uppercase">{title}</div>
            <div className="text-14 font-medium text-white/50">{subTitle}</div>
          </div>
        </div>
        <Button className="shrink-0 size-8 p-0" color="gray" variant="soft" onClick={handleClose}>
          <CrossIcon className="size-3" />
        </Button>
      </div>
      {children}
    </div>
  );
}
